import { useState } from "react";
import { Bot, GraduationCap } from "lucide-react";

const CHATBOT_TRANSCRIPT = [
  { role: "student", text: "What is 3/4 + 1/4?" },
  { role: "ai", text: "3/4 + 1/4 = 1. Next question?" },
];
const SOCRATIC_TRANSCRIPT = [
  { role: "student", text: "What is 3/4 + 1/4?" },
  { role: "ai", text: "Good one! Since both fractions already share the same denominator, what do you think we add — the numerators, or the denominators?" },
  { role: "student", text: "The numerators?" },
  { role: "ai", text: "Exactly! So 3 + 1 = 4, over the same denominator 4. What does 4/4 simplify to?" },
  { role: "student", text: "1!" },
  { role: "ai", text: "You solved it yourself. That's how real mastery sticks." },
];

export default function LandingSocraticDemo() {
  const [mode, setMode] = useState("socratic");
  const transcript = mode === "socratic" ? SOCRATIC_TRANSCRIPT : CHATBOT_TRANSCRIPT;

  return (
    <section id="socratic" className="py-10 sm:py-16 bg-slate-900 text-white border-y border-slate-800" data-testid="landing-socratic-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-1.5 bg-indigo-500/15 text-indigo-300 border border-indigo-400/30 rounded-full px-3 py-1 text-xs font-bold" data-testid="socratic-first-badge">
          <GraduationCap size={12} /> Industry First · Pure Socratic Method AI Tutor
        </span>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-3 text-white">Socratic AI vs. a Standard Chatbot</h2>
        <p className="text-slate-300 mt-3 max-w-xl mx-auto">
          A chatbot gives answers. SmartGuru asks the right question so your child gets there themselves — and actually remembers it.
        </p>
        <div className="inline-flex bg-slate-800 border border-slate-700 rounded-full p-1 mt-7" data-testid="socratic-toggle">
          <button
            onClick={() => setMode("chatbot")}
            data-testid="socratic-toggle-chatbot"
            className={`px-5 py-2 rounded-full text-sm font-bold flex items-center gap-1.5 transition-all ${mode === "chatbot" ? "bg-slate-600 text-white" : "text-slate-400"}`}
          >
            <Bot size={15} /> Standard Chatbot
          </button>
          <button
            onClick={() => setMode("socratic")}
            data-testid="socratic-toggle-socratic"
            className={`px-5 py-2 rounded-full text-sm font-bold flex items-center gap-1.5 transition-all ${mode === "socratic" ? "bg-primary text-primary-foreground" : "text-slate-400"}`}
          >
            <GraduationCap size={15} /> SmartGuru Socratic AI
          </button>
        </div>
        <div className="bg-slate-800 border border-slate-700 rounded-3xl p-6 mt-6 text-left space-y-3 max-w-lg mx-auto min-h-[220px]" data-testid="socratic-transcript">
          {transcript.map((t, i) => (
            <div
              key={i}
              className={`rounded-2xl px-4 py-2.5 text-sm max-w-[85%] ${t.role === "student" ? "bg-slate-700 text-slate-100 rounded-tl-sm" : "bg-indigo-500/20 border border-indigo-400/30 text-indigo-100 ml-auto rounded-tr-sm"}`}
            >
              {t.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
